import React from 'react'
import { withRouter } from 'react-router'
import { BreadcrumbContainer, Link, SeparateSpan, Span } from './styled'
import { generateBreadcrumbs } from '../../utils/getCurrentRoute'

function Breadcrumbs({ location }) {
  const currentPath = location.pathname
  let breadcrumbs = generateBreadcrumbs(currentPath)
    
  const showBreadcrumbs = currentPath !== '/inicio';

  return (
    <>
      {showBreadcrumbs && (
        <BreadcrumbContainer>
          {breadcrumbs.map(({ path, breadcrumb }, idx) => {
            const isCurrent = path === currentPath
            return (
              <Span key={path}>
                {idx > 0 && <SeparateSpan>/</SeparateSpan>}
                <Link to={path} current={isCurrent ? 'true' : undefined}>
                  {breadcrumb}
                </Link>
              </Span>
            )
          })}
        </BreadcrumbContainer>
      )}
    </>
  )
}

export default withRouter(Breadcrumbs)